export const manifest = {
  screens: {
    scr_03z964: { name: "Login", route: "/", state: {"currentScreen":"login"}, position: {"x":1560,"y":220} },
    scr_3nq7x7: { name: "BOP Signup", route: "/", state: {"currentScreen":"bop-signup"}, position: {"x":2960,"y":220} },
    scr_2ikdzh: { name: "Forgot Password", route: "/", state: {"currentScreen":"forgot-password"}, position: {"x":4360,"y":220} },
    scr_awuqna: { name: "MPIN", route: "/", state: {"currentScreen":"mpin"}, position: {"x":5760,"y":220} },
    scr_srwcc9: { name: "Home Dashboard", route: "/", state: {"currentScreen":"home"}, position: {"x":160,"y":2200} },
    scr_g42euy: { name: "Transactions", route: "/", state: {"currentScreen":"transactions"}, position: {"x":1560,"y":2200} },
    scr_tfn86j: { name: "Send Money", route: "/", state: {"currentScreen":"send-money"}, position: {"x":-2152.17,"y":3763.05} },
    scr_ya110q: { name: "Mobile Top-Up", route: "/", state: {"currentScreen":"mobile-topup"}, position: {"x":465.62,"y":3786.5} },
    scr_1shimf: { name: "Raast", route: "/", state: {"currentScreen":"raast"}, position: {"x":647.83,"y":3763.05} },
    scr_emmejk: { name: "Bills & Payments", route: "/", state: {"currentScreen":"payments"}, position: {"x":2047.83,"y":3763.05} },
    scr_kr3j2q: { name: "Cards", route: "/", state: {"currentScreen":"cards"}, position: {"x":160,"y":6160} },
    scr_u1h3e0: { name: "Rewards", route: "/", state: {"currentScreen":"rewards"}, position: {"x":1560,"y":6160} },
    scr_dok8km: { name: "Cooling Off", route: "/", state: {"currentScreen":"cooling-off"}, position: {"x":1560,"y":8140} },
    scr_ubdgoi: { name: "Profile", route: "/", state: {"currentScreen":"profile"}, position: {"x":160,"y":8140} },
    scr_2rtvzt: { name: "More Services / Zakat", route: "/", state: {"currentScreen":"more"}, position: {"x":2960,"y":8140} },
  },
  sections: {
    sec_lkqunt: { name: "Authentication & Onboarding", x: 0, y: 0, width: 7120, height: 1180 },
    sec_nvdc0d: { name: "Dashboard & Activity", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_r2bty2: { name: "Money Transfer & Payments", x: -2312.17, y: 3543.05, width: 5720, height: 1180 },
    sec_2xvwk7: { name: "Cards & Rewards", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_uajloo: { name: "Profile & Settings", x: 0, y: 7920, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_lkqunt", children: [
      { kind: "screen", id: "scr_03z964" },
      { kind: "screen", id: "scr_3nq7x7" },
      { kind: "screen", id: "scr_2ikdzh" },
      { kind: "screen", id: "scr_awuqna" },
    ] },
    { kind: "section", id: "sec_nvdc0d", children: [
      { kind: "screen", id: "scr_srwcc9" },
      { kind: "screen", id: "scr_g42euy" },
    ] },
    { kind: "section", id: "sec_r2bty2", children: [
      { kind: "screen", id: "scr_tfn86j" },
      { kind: "screen", id: "scr_ya110q" },
      { kind: "screen", id: "scr_1shimf" },
      { kind: "screen", id: "scr_emmejk" },
    ] },
    { kind: "section", id: "sec_2xvwk7", children: [
      { kind: "screen", id: "scr_kr3j2q" },
      { kind: "screen", id: "scr_u1h3e0" },
    ] },
    { kind: "section", id: "sec_uajloo", children: [
      { kind: "screen", id: "scr_ubdgoi" },
      { kind: "screen", id: "scr_dok8km" },
      { kind: "screen", id: "scr_2rtvzt" },
    ] },
  ],
}
